import { Badge } from 'components/shared/Badge';
import { Heading2 } from 'components/shared/Typography';
import { useI18n } from 'hooks/useI18n';
import { Element } from 'react-scroll';
import { getPublicPath } from 'utils/paths';
import {
  StyledCompanies,
  StyledContainer,
  StyledFeature,
  StyledFeatureDesc,
  StyledFeatureIcon,
  StyledFeatures,
  StyledFeatureTitle
} from './ApplicationsCompanies.styled';

const ApplicationsCompanies: React.FC = () => {
  const { t } = useI18n('applications-landing');

  const features = [
    {
      icon: getPublicPath('/images/icons/legal_dark.svg'),
      title: t('applicationsLanding.companies.legal.title'),
      desc: t('applicationsLanding.companies.legal.desc')
    },
    {
      icon: getPublicPath('/images/icons/update_dark.svg'),
      title: t('applicationsLanding.companies.updated.title'),
      desc: t('applicationsLanding.companies.updated.desc')
    },
    {
      icon: getPublicPath('/images/icons/chat_dark.svg'),
      title: t('applicationsLanding.companies.feedback.title'),
      desc: t('applicationsLanding.companies.feedback.desc'),
      soon: true
    }
  ];
  return (
    <Element id="jobAppsCompanies" name="jobAppsCompanies">
      <StyledCompanies>
        <StyledContainer>
          <Heading2 editorial>
            {t('applicationsLanding.companies.title')}
          </Heading2>
          <StyledFeatures>
            {features.map((feature, index) => (
              <StyledFeature key={index}>
                <StyledFeatureIcon src={feature.icon} alt="" />
                <StyledFeatureTitle>{feature.title}</StyledFeatureTitle>
                <StyledFeatureDesc
                  dangerouslySetInnerHTML={{
                    __html: feature.desc
                  }}
                ></StyledFeatureDesc>
                {feature.soon && (
                  <Badge variant="secondaryInverse">
                    {t('applicationsLanding.companies.soon')}
                  </Badge>
                )}
              </StyledFeature>
            ))}
          </StyledFeatures>
        </StyledContainer>
      </StyledCompanies>
    </Element>
  );
};

export default ApplicationsCompanies;
